import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

function CollapsibleSection({
  title,
  description,
  summary,
  defaultOpen = false,
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="rounded-xl border border-surface-border bg-white">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex w-full items-start justify-between gap-3 px-4 py-3 text-left"
        aria-expanded={open}
      >
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-content-primary">{title}</p>
          {description && (
            <p className="mt-0.5 text-xs text-content-muted leading-relaxed">{description}</p>
          )}
          {!open && summary && (
            <p className="mt-1 text-xs text-forge-600">{summary}</p>
          )}
        </div>
        <span className="inline-flex shrink-0 items-center gap-1 rounded-lg border border-surface-border bg-slate-50 px-2 py-1 text-xs font-medium text-content-muted">
          {open ? (
            <>
              <ChevronUp className="h-3.5 w-3.5" aria-hidden />
              Ocultar
            </>
          ) : (
            <>
              <ChevronDown className="h-3.5 w-3.5" aria-hidden />
              Expandir
            </>
          )}
        </span>
      </button>

      {open && (
        <div className="space-y-4 border-t border-surface-border px-4 py-4">
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleSection;
